// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"96b8de29","62":"3e68ebc5","125":"dd95bb70","443":"1d4cc0ef","636":"a4c6a561"}[chunkId] + ".chunk.js";
};